import { DeviceUUID } from 'device-uuid';

async function getDeviceId(): Promise<string> {
  const deviceUUID: string = new DeviceUUID().get();

  return `${deviceUUID}`;
}

export { getDeviceId };
